<template>
  <Catalogs
    title="Услуги самозанятых"
    create-text="Новая"
    :fetch-data="fetchData"
    :route-create="'WorkServiceAdd'"
    :route-edit="'WorkServiceEdit'"
    :route-view="'WorkServiceView'"
    :route-path="'/work_services'"
    :can-edit="canEditWorkServiceCatalogs()"
  />
</template>

<script>
import catalogs from "../../../network/catalogs";
  import permissions, {PERM} from "../../../utilites/permissions";
   import Catalogs from "../Catalogs.vue";

export default {
  name: "WorkServices",
  components: { Catalogs },
  mixins: [
    catalogs,
    permissions
  ],
  methods: {
    async fetchData(data) {
      return await this.getWorkServices(data);
    },
    canEditWorkServiceCatalogs() {
      return this.hasPermission([PERM.CATALOG_WORK_SERVICE_EDIT]);
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/Catalogs/WorkServices/WorkServices.vue